import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import palette from 'src/theme/palette';

const SubProjectDialog = ({ open, onClose, subProject }) => {
  if (!subProject) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: palette.primary.main,
          height: 50
        }}
      >
        <Typography
          sx={{ fontSize: 20, fontFamily: 'poppinsBold', color: palette.primary.titledark }}
        >
          Sub Project Details
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: '#000' }} />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent dividers>
        {/* Name */}
        <Box sx={{ mb: 2 }}>
          <Typography
            sx={{
              fontSize: 18,
              fontFamily: 'poppinsSemiBold',
              color: palette.primary.main,
              textTransform: 'capitalize'
            }}
          >
            Sub Project Name
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              fontFamily: 'poppinsMedium',
              color: palette.primary.titledark
            }}
          >
            {subProject?.name || 'N/A'}
          </Typography>
        </Box>

        {/* Description */}
        <Box>
          <Typography
            sx={{
              fontSize: 18,
              fontFamily: 'poppinsSemiBold',
              color: palette.primary.main,
              textTransform: 'capitalize'
            }}
          >
            Description
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              fontFamily: 'poppinsMedium',
              color: palette.primary.titledark
            }}
          >
            {subProject?.description || 'N/A'}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SubProjectDialog;
